import {useState  } from "react";
import { Spinner, Flex, AlertIcon, AlertDescription, FormLabel, useColorModeValue } from '@chakra-ui/react'; 
import MiniCalendar from 'components/calendar/MiniCalendar';


export default function DateRangeSelect(props: { onChangeSelection: any; })  {
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
	  
    const [values, setValues] = useState([
        new Date("2014-01-01T00:00:00.000Z"),
        new Date()
      ])

	return (    
    <Flex direction='column'>
							<FormLabel
								ms='10px'
								htmlFor='dateRanges'
								fontSize='sm'
								color={textColorPrimary}
								fontWeight='bold'
								_hover={{ cursor: 'pointer' }}>
								Rango de fechas
							</FormLabel>
                            <MiniCalendar selectRange onChangeSelection={props.onChangeSelection} />
                </Flex>
  );
}